var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.792 0.886721L9.57794 0.88672L9.57794 14.582L0.737302 14.582L11.6858 30.3848L22.6342 14.582L13.792 14.582L13.792 0.886721Z","fill":"currentColor"}));
}

ArrowDown.defaultProps = {"width":"23","height":"31","viewBox":"0 0 23 31","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
